import { LedgerDetails } from "../Components/index.js";

export default [
    {
        path: "/reports/account/audit-ledger",
        component: LedgerDetails,
        name: "report.account.audit-ledger",
        meta: {
            requiresAuth: true,
        },
    },
];
